
import { Helmet } from "react-helmet";

const EnglishPrivacyPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>Privacy Policy - Lainasampo.fi</title>
        <meta name="description" content="Privacy Policy for Lainasampo.fi loan comparison service" />
      </Helmet>

      <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-sm">
        <h1 className="text-3xl font-bold text-blue-800 mb-6">Privacy Policy</h1>
        
        <div className="prose prose-blue max-w-none">
          <p className="text-sm text-gray-500 mb-4">
            This is a translation of our Finnish Privacy Policy. The Finnish version is the legally binding version.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">1. Data Controller</h2>
          <p>
            Pulaton Oy is responsible for the privacy of the Lainasampo.fi service.
            <br />
            Business ID: 3308199-4
            <br />
            Email: asiakaspalvelu@lainasampo.fi
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">2. Collected Information</h2>
          <p>
            We collect the following information from users for loan offer processing:
          </p>
          <ul className="list-disc pl-5 mb-4">
            <li>Name and contact details (email address, phone number)</li>
            <li>Personal identification information</li>
            <li>Employment and income information</li>
            <li>Loan-related information (desired amount, purpose, term)</li>
            <li>Financial information (existing loans, expenses)</li>
            <li>Technical information (IP address, browser type, device information)</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">3. Information Usage</h2>
          <p>
            We use your information for the following purposes:
          </p>
          <ul className="list-disc pl-5 mb-4">
            <li>To process your loan application</li>
            <li>To request loan offers from our partner financial institutions</li>
            <li>To communicate with you about your application</li>
            <li>To improve our service and user experience</li>
            <li>To fulfill our legal obligations</li>
            <li>For statistical analysis and service development</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">4. Information Disclosure</h2>
          <p>
            We disclose your information to:
          </p>
          <ul className="list-disc pl-5 mb-4">
            <li>Our partner financial institutions for the purpose of making loan offers</li>
            <li>Service providers who assist us in operating our website and providing our services</li>
            <li>Authorities when required by law</li>
          </ul>
          <p>
            Information is not disclosed for marketing purposes without your explicit consent.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">5. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal 
            information against unauthorized access, disclosure, alteration, and destruction.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">6. Data Storage</h2>
          <p>
            We store your information for as long as necessary to fulfill the purposes for which it 
            was collected, to comply with legal obligations, or to protect our legitimate interests.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">7. Your Rights</h2>
          <p>
            You have the right to:
          </p>
          <ul className="list-disc pl-5 mb-4">
            <li>Access your personal data</li>
            <li>Rectify inaccurate personal data</li>
            <li>Request the erasure of your personal data</li>
            <li>Restrict or object to the processing of your personal data</li>
            <li>Data portability</li>
            <li>Withdraw your consent at any time</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">8. Contact Information</h2>
          <p>
            If you have any questions about our Privacy Policy or how we handle your personal data, 
            please contact us at:
            <br />
            Email: asiakaspalvelu@lainasampo.fi
          </p>
        </div>
      </div>
    </div>
  );
};

export default EnglishPrivacyPage;
